<template>
  <div class="cmp-footer-wrap" :class="{'mobile': _isMobile, 'pc': !_isMobile}">
    <div class="cmp-footer">
      <!-- <div class="footer-wrap g-wrap g-container"> -->
      <div class="footer-wrap">
        <!-- <p class="mb-20" style="font-size:18px;color:#fff;">友情链接</p> -->
        <!-- <div class="top">
          <div class="footer-link">
            <div class="link-tab" v-for="(item,index) in dataList" :key="index">
              <div class="item">
                <router-link tag="a" :to="item.url" class="name mb-20" replace>{{item.name}}</router-link>
                <router-link tag="a" :to="it.url" v-for="(it,i) in item.childList" :key="i" replace>{{it.name}}
                  <template v-if="it.child">
                    <router-link tag="p" :to="child.url" v-for="child in it.child" replace><i class="ml-5 mr-5">· </i>{{child.name}}</router-link>
                  </template>
                </router-link>
              </div>
            </div>
          </div>
        </div> -->

        <div class="contact">
          <div class="addr">
            <p class="name">长春博物馆地址</p>
            <p>{{$store.state.app.globalInfo.museumInfo.address}}</p>
          </div>
          <div class="phone">
            <p class="name">联系电话</p>
            <p>{{$store.state.app.globalInfo.museumInfo.telphone}}</p>
          </div>
          <!-- <img class="foot-logo" src="~@images/logo-2.png" alt=""> -->
        </div>

        <div class="other-links">
          <p>友情链接：</p>
          <ul>
            <li v-for="(item, i) in $store.state.app.globalInfo.friendLink" :key="i">
              <a :href="item.url" target="_blank">{{item.name}}</a>
            </li>
            <!-- <li>
              <a href="https://www.cddfct.com/" target="_blank">成都杜甫草堂博物馆</a>
            </li>
            <li>
              <a href="https://www.cddfct.com/" target="_blank">成都金沙遗址博物馆</a>
            </li>
            <li>
              <a href="https://www.cddfct.com/" target="_blank">成都博物馆</a>
            </li>
            <li>
              <a href="https://www.cddfct.com/" target="_blank">成都永陵博物馆</a>
            </li> -->
          </ul>
        </div>


        <div class="bottom">
          <div class="icons-link">
            <div class="icon-list">
              <div class="icon-item" v-for="(item, i) in focusList" :key="i">
                <img class="link_pic" :src="item.url" alt="">

                <div class="pic-pop anim">
                  <div class="pic">
                    <img :src="item.qrcode" alt="" title="">
                  </div>
                </div>
              </div>
              <!-- <div class="icon-item">
                <img src="~@images/foot-wechat.png" alt="">
              </div>
              <div class="icon-item">
                <img src="~@images/foot-link.png" alt="">
              </div>
              <div class="icon-item">
                <img src="~@images/foot-douyin.png" alt="">
              </div> -->
            </div>

            <!-- <p class="name">版权所有：武侯祠博物馆 豫ICP备字11111111号</p> -->
          </div>
        </div>

        <div class="footer-suport mt-10">
          <p>版权所有：{{$store.state.app.globalInfo.museumInfo.copyright}} 
            <template v-if="!_isMobile">
              <img src="~@images/beian.png" alt="" style="width: 14px;margin-right: 5px;margin-left: 10px;top:2px;position:relative;"> 
              <a href="https://beian.mps.gov.cn/#/query/webSearch?code=22010202001268" rel="noreferrer" target="_blank" style="margin-right: 10px;">吉公网安备22010202001268号</a >
              <span>吉ICP备20002756号</span>
            </template>
          </p>

          <p v-if="_isMobile">
            <img class="icon_beian" src="~@images/beian.png" alt="" style="width: 14px;margin-right: 5px;margin-left: 10px;top:2px;position:relative;"> 
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=22010202001268" rel="noreferrer" target="_blank" style="margin-right: 10px;">吉公网安备22010202001268号</a >
          </p>
          <p v-if="_isMobile">吉ICP备20002756号</p>


          <!-- <p>版权所有：{{$store.state.app.globalInfo.museumInfo.copyright}} {{$store.state.app.globalInfo.museumInfo.icp}}</p> -->
          
          <!-- <p>辽ICP备11007072号-1</p>
          <p>版权所有：Copyright©2022 辽宁省博物馆 All Rights Reserved.</p>
          <p>技术支持：北京探景科技有限公司</p> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import '@assets/css-mobile/common.scss'
// import QrcodeVue from 'qrcode.vue'
// import Popper from 'vue-popperjs';
// import 'vue-popperjs/dist/vue-popper.css';
export default {
  components: {
    // QrcodeVue,
    // popper: Popper
  },
  watch: {
    "$store.state.app.globalInfo.museumInfo":{
      // deep: true,
      handler(newVal, oldVal) {
        this.focusList = [
          {
            name: '小程序',
            url: require('@images/foot-link.png'),
            qrcode: newVal.qrcodeXcx,
          },
          // {
          //   name: '微博',
          //   url: require('@images/foot-webo.png'),
          //   qrcode: require('@images/foot-webo.png'),
          // },
          {
            name: '抖音',
            url: require('@images/foot-douyin.png'),
            qrcode: newVal.qrcodeDy,
          },
          {
            name: '微信',
            url: require('@images/foot-wechat.png'),
            qrcode: newVal.qrcodeWx,
          }
        ]
      }
    }
  },
  data() {
    return {
      visible: false,
      dataList: [
        {
          name: '首页',
          url: '/home'
        },
        {
          name: '资讯动态',
          url: '/information',
        //   childList: [
        //     {
        //       name: '关于我们',
        //       url: '/information',
        //       // child: [
        //       //   {
        //       //     name: '南阳武侯祠博物馆',
        //       //     url: '/information?pageType=1&subType=1',
        //       //   },
        //       //   {
        //       //     name: '南阳武侯祠',
        //       //     url: '/information?pageType=1&subType=2',
        //       //   }
        //       // ]
        //     },
        //     {
        //       name: '博物馆章程',
        //       url: '/information?pageType=2',
        //     },
        //     {
        //       name: '新闻动态',
        //       url: '/information?pageType=3',
        //     },
        //     {
        //       name: '机构设置',
        //       url: '/information?pageType=4',
        //     },
        //     // {
        //     //   name: '联系我们',
        //     //   url: '/information?pageType=5',
        //     // }
        //   ]
        },
        // {
        //   name: '参观',
        //   url: '/visit',
        //   childList: [
        //     // {
        //     //   name: '景区地图',
        //     //   url: '/visit?pageType=1'
        //     // },
        //     {
        //       name: '参观预约',
        //       url: '/visit?pageType=2'
        //     },
        //     {
        //       name: '馆内服务',
        //       url: '/visit?pageType=3'
        //     },
        //     {
        //       name: '位置周边',
        //       url: '/visit?pageType=4'
        //     }
        //   ]
        // },
        {
          name: '陈列展览',
          url: '/exhibition',
          childList: [
            {
              name: '常设展览',
              url: '/exhibition'
            },
            {
              name: '临时展览',
              url: '/exhibition?pageType=2'
            },
            {
              name: '虚拟展厅',
              url: '/exhibition?pageType=3'
            }
          ]
        },
        {
          name: '馆藏精品',
          url: '/collect',
          childList: [
            {
              name: '藏品数据库',
              url: '/collect',
            },
            {
              name: '藏品征集',
              url: '/collect?pageType=2',
            },
            // {
            //   name: '古建遗迹',
            //   url: '/collect?pageType=3',
            // },
          ]
        },
        {
          name: '社会教育',
          url: '/activity',
          childList: [
            {
              name: '社教活动',
              url: '/activity'
            },
            {
              name: '游学活动',
              url: '/activity?pageType=2'
            },
            {
              name: '讲座',
              url: '/activity?pageType=3'
            },
            {
              name: '手工',
              url: '/activity?pageType=4'
            },
            {
              name: '其他',
              url: '/activity?pageType=5'
            },
          ]
        },
        {
          name: '视频资源',
          url: '/video',
          childList: [
            {
              name: '讲解',
              url: '/video',
            },
            {
              name: '宣传',
              url: '/video?pageType=2',
            },
            {
              name: '讲座',
              url: '/video?pageType=3',
            },
            {
              name: '其他',
              url: '/video?pageType=4',
            },
          ]
        },
        {
          name: '通知公告',
          url: '/notice',
        },
        {
          name: '关于我们',
          url: '/about',
        },
        {
          name: '公众服务',
          url: '/service',
          childList: [
            {
              name: '志愿者',
              url: '/service',
            },
            {
              name: '失物登记',
              url: '/service?pageType=2',
            },
            {
              name: '观众留言',
              url: '/service?pageType=3',
            }
          ]
        },
        // {
        //   name: '文化',
        //   url: '/exhibition',
        //   childList: [
        //     {
        //       name: '博物院通票',
        //       url: '/culture',
        //     },
        //     {
        //       name: '出土文物',
        //       url: '/culture?pageType=2',
        //     },
        //     // {
        //     //   name: '三国文化园地',
        //     //   url: '/culture?pageType=3',
        //     // },
        //     // {
        //     //   name: '社会名人及团体',
        //     //   url: '/culture?pageType=4',
        //     // },
        //     // {
        //     //   name: '爱国主义教育基地',
        //     //   url: '/culture?pageType=5',
        //     // },
        //     // {
        //     //   name: '青年志愿者实习基地',
        //     //   url: '/culture?pageType=6',
        //     // }
        //   ]
        // }
      ],
      focusList: [],

      dataList2: [
        {
          name: '首页',
          url: '/home',
          childList: []
        },
        {
          name: '展览',
          url: '/exhibition',
          childList: [
            {
              name: '陈列展览',
              url: '/exhibition?type=1'
            },
            {
              name: '临时展览',
              url: '/exhibition?type=2'
            },
            {
              name: '数字展览',
              url: '/exhibition?type=3'
            }
          ]
        },
        {
          name: '馆藏',
          url: '/collect',
          childList: [
            {
              name: '馆藏精品',
              url: '/collect?type=1'
            },
            {
              name: '藏品数据库',
              url: '/collect?type=2'
            },
            {
              name: '藏品征集',
              url: '/collect?type=3'
            },
            {
              name: '社会捐赠',
              url: '/collect?type=4'
            }
          ]
        },
        {
          name: '教育',
          url: '/activity',
          childList: [
            {
              name: '社交活动',
              url: '/activity'
            }
          ]
        },
        {
          name: '研究',
          url: '/research',
          childList: [
            {
              name: '科研课题',
              url: '/research?type=1'
            },
            {
              name: '学术会议',
              url: '/research?type=2'
            },
            {
              name: '专著',
              url: '/research?type=3'
            },
            {
              name: '年鉴',
              url: '/research?type=4'
            },
            {
              name: '论文',
              url: '/research?type=4'
            },
            {
              name: '馆刊',
              url: '/research?type=4'
            }
          ]
        },
        {
          name: '文创',
          url: '/creative',
          childList: [
            {
              name: '文创列表',
              url: '/creative'
            }
          ]
        },
        {
          name: '动态',
          url: '/dynamic',
          childList: [
            {
              name: '新闻资讯',
              url: '/dynamic?type=1'
            },
            {
              name: '通知公告',
              url: '/dynamic?type=2'
            },
            {
              name: '视频资源',
              url: '/dynamic?type=3'
            }
          ]
        },
        {
          name: '概览',
          url: '/overview',
          childList: [
            {
              name: '关于我馆',
              url: '/overview?type=1'
            },
            {
              name: '管理与建设',
              url: '/overview?type=2'
            },
            {
              name: '参观服务',
              url: '/overview?type=3'
            },
            {
              name: '联系我们',
              url: '/overview?type=4'
            }
          ]
        },
        {
          name: '志愿者',
          url: '/volunteer',
          childList: []
        }
      ]
    }
  },
  methods: {
    close() {
      this.visible = true
      this.$nextTick(() => {
        this.visible = false
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.cmp-footer {
  padding: 30px 0;
  background: #222222;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  // height: 196px;
  // background: url(~@images/footer-bg.jpg) no-repeat top center;
  // background-size: cover;
  // position: absolute;
  // left: 0;
  // bottom: 0;
  // width: 100%;
  a {
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    margin-bottom: 10px;
    p {
      font-size: 12px;
      line-height: 20px;
      color: rgba(255, 255, 255, 0.5);
      &:nth-child(1) {
        margin-top: 5px;
      }
    }
  }
  .footer-wrap {
    // display: flex;
    width: $minWidth;
    // width: 1142px;
    margin: 0 auto;
    .top {
      flex: 1;
      .footer-link {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .link-tab {
          margin-bottom: 50px;
          // margin-right: 60px;
          // width: 270px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          .item {
            padding-left: 10px;
            // border-left: solid 1px $primary;
            display: flex;
            flex-direction: column;
            .name {
              font-size: 14px;
              font-weight: bold;
            }
            .link-btn {
              margin-bottom: 10px;
              font-size: 16px;
            }
          }
        }
      }
    }
  }
  .contact {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    // padding-left: 140px;
    
    .phone {
      margin: 20px 0;
      // margin-right: 250px;
      margin-left: 100px;
    }
    .name {
      opacity: 0.7;
      margin-bottom: 4px;
    }
    .foot-logo {
      width: 100px;
    }
  }
  .other-links {
    margin: 40px 0;
    display: flex;
    justify-content: center;
    font-size: 14px;
    ul {
      display: flex;
      li {
        margin-left: 20px;
      }
    }
  }
  .footer-suport {
    // background: #292428;
    // background: rgba($color: #292428, $alpha: .5);
    text-align: center;
    font-size: 14px;
    p {
      margin-bottom: 5px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .bottom {
    display: flex;
    justify-content: center;
    text-align: center;
    font-size: 16px;
    .name {
      margin-top: 40px;
      margin-bottom: 10px;
      font-size: 18px;
    }
    .icons-link {
      .icon-list {
        margin-top: 15px;
        display: flex;
        .icon-item {
          position: relative;
          margin-right: 20px;
          cursor: pointer;
          &:last-child {
            margin-right: 0;
          }
          img {
            width: 30px;
            height: 30px;
            object-fit: contain;
          }

          .pic-pop.anim {
            position: absolute;
            left: 50%;
            bottom: 100%;
            margin-bottom: 10px;
            opacity: 0;
            padding: 8px;
            visibility: hidden;
            border-radius: 5px;
            // transition: all 0.3s;
            background: #fff;
            transform: translate(-50%, 0%);
            &::before {
              content: '';
              width: 12px;
              height: 12px;
              background-color: #fff;
              border: 1px solid #ddd;
              position: absolute;
              z-index: -1;
              left: 50%;
              top: 100%;
              transform: translate(-50%, -50%) rotate(45deg);
            }
            &:after {
              content: '';
              position: absolute;
              z-index: -1;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              background-color: #fff;
              border-radius: 5px;
            }
            .pic {
              width: 137px;
              img {
                width: 100%;
                height: 137px;
              }
            }
          }
          &:hover {
            .link_pic {
              opacity: 0.6;
            }
            .pic-pop {
              opacity: 1;
              visibility: visible;
            }
            .pic-pop.anim {
              // transform: translate(-50%, 0%);
            }
          }
        }
      }
    }
  }
}
</style>
